var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMsSearchSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.072 18.2L22 22M20.7333 11.8667C20.7333 16.7636 16.7636 20.7333 11.8667 20.7333C6.96974 20.7333 3 16.7636 3 11.8667C3 6.96974 6.96974 3 11.8667 3C16.7636 3 20.7333 6.96974 20.7333 11.8667Z",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17C8.22957 16.6646 8.5717 16.2153 9.33831 15.4363C9.61751 15.1526 9.95999 15 10.3139 15C11.1697 15 12.8187 15 13.6786 15C14.0367 15 14.3826 15.1591 14.6708 15.4361C15.6607 16.3874 16 17 16 17",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9.5,
    r: 2.5,
    stroke: "#FFF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMsSearchSelected);
export default __webpack_public_path__ + "static/media/ic_ms_search_selected.f288336c02ba544cefc2dbe3500eb0d1.svg";
export { ForwardRef as ReactComponent };